import componentReducer from './componentReducer';
import { INITIALIZE_COMPONENT, SET_ERROR, CLEAR_ERROR } from './types';

const reducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE_COMPONENT: return ({ error: {}, data: action.component, isEdit: true });
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case CLEAR_ERROR: {
      const newErrors = { ...state.error };
      delete newErrors[action.payload];
      return {
        ...state,
        error: newErrors,
      };
    }
    default: return componentReducer(state, action);
  }
};

export default reducer;
